import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoListComponent, InfoListItemComponent } from '@markant-platform/cartridge/ui-booking';
import { TranslocoPipe } from '@jsverse/transloco';
import { OrganizationService } from '@markant-platform/shared/organization/data-access';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthenticatedUserService } from '@markant-platform/shared/user/data-access';

@Component({
  selector: 'markant-platform-contract-partner-info',
  standalone: true,
  imports: [CommonModule, InfoListComponent, InfoListItemComponent, TranslocoPipe],
  templateUrl: './contract-partner-info.component.html',
  styleUrl: './contract-partner-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContractPartnerInfoComponent {
  private organizationService: OrganizationService = inject(OrganizationService);
  private authenticatedUserService: AuthenticatedUserService = inject(AuthenticatedUserService);

  organization = toSignal(this.organizationService.getCurrentOrganization());
  user = toSignal(this.authenticatedUserService.getUser());
}
